import React from 'react';

// Importar las imágenes
import logoSrc from '@/assets/images/signature/logo_firma.png'
import phoneIcon from '@/assets/images/signature/icon_call.png';
import emailIcon from '@/assets/images/signature/icon_mail.png';
import locationIcon from '@/assets/images/signature/icon_distance.png';
import websiteIcon from '@/assets/images/signature/icon_link.png';
import linkedinIcon from '@/assets/images/signature/icon_linkedin.png';
import twitterIcon from '@/assets/images/signature/icon_twitter.png';
import facebookIcon from '@/assets/images/signature/icon_facebook.png';

interface SocialMedia {
  platform: 'LinkedIn' | 'Twitter' | 'Facebook';
  url: string;
}

interface EmailSignatureProps {
  name: string;
  position?: string;
  phone: string;
  extension?: string;
  email: string;
  address: string;
  website: string;
  socialMedia: SocialMedia[];
}

const EmailSignature: React.FC<EmailSignatureProps> = ({
  name,
  position,
  phone,
  extension,
  email,
  address,
  website,
  socialMedia
}) => {
    const getSocialIcon = (platform: string) => {
      switch (platform) {
        case 'LinkedIn':
          return linkedinIcon;
        case 'Twitter':
          return twitterIcon;
        case 'Facebook':
          return facebookIcon;
        default:
          return '';
      }
    };
  
    return (
    <div style={{ padding: '20px' }}>
      <div>
        <div id="synapses-Sign">
          <div style={{ padding: '20px' }}>
            <div
              style={{
                maxWidth: '265px',
                display: 'inline-block',
                borderRight: '1px solid rgb(246, 246, 246)',
                marginRight: '60px',
                paddingRight: '70px',
                backgroundColor: 'rgb(246, 246, 246)',
                height: '265px',
                borderTopRightRadius: '90px',
                borderBottomRightRadius: '90px'
              }}
            >
              <div>
                <img
                  alt="synapses Logo"
                  height="2265px"
                  src={logoSrc}
                  width="265px"
                  style={{ paddingLeft: '20px', paddingTop: '20px', paddingBottom: '20px' }}
                />
              </div>
            </div>
            <div style={{ display: 'inline-block', verticalAlign: 'top' }}>
              <div>
                <h2 style={{ color: 'rgb(51, 149, 255)', fontWeight: 'bold', fontSize: '25px', fontFamily: 'sans-serif' }}>
                  {name}
                </h2>
                {position && <p style={{ color: '#9b9b9b', fontSize: '18px', margin: '0 0 15px 0' }}>{position}</p>}
                {!position && <div style={{ height: '23px', margin: '0 0 15px 0' }}></div>}
              </div>
              <div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                    <img
                    src={phoneIcon}
                    style={{ width: '16px', height: '16px', marginRight: '8px' }}
                    />
                    <a 
                    href={`tel:${phone.replace(/\s+/g, '')}`}
                    style={{ 
                        fontSize: '14px', 
                        color: '#9b9b9b', 
                        fontFamily: 'Arial, sans-serif',
                        textDecoration: 'none'
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                    {phone}
                    {extension && <span style={{ marginLeft: '5px' }}>/ Ext. {extension}</span>}
                    </a>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                    <img
                    src={emailIcon}
                    style={{ width: '16px', height: '16px', marginRight: '8px' }}
                    />
                    <a
                    href={`mailto:${email}`}
                    style={{ 
                        fontSize: '14px', 
                        color: '#9b9b9b', 
                        fontFamily: 'Arial, sans-serif',
                        textDecoration: 'none'
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                    {email}
                    </a>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                    <img
                    src={locationIcon}
                    style={{ width: '16px', height: '16px', marginRight: '8px' }}
                    />
                    <span style={{ 
                    fontSize: '14px', 
                    color: '#9b9b9b', 
                    fontFamily: 'Arial, sans-serif'
                    }}>
                    {address}
                    </span>
                </div>
 
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                    <img
                    src={websiteIcon}
                    style={{ width: '16px', height: '16px', marginRight: '8px' }}
                    />
                    <a
                    href={website}
                    style={{ 
                        fontSize: '14px', 
                        color: '#9b9b9b', 
                        fontFamily: 'Arial, sans-serif',
                        textDecoration: 'none'
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                    {website.replace(/^https?:\/\//, '')}
                    </a>
                </div>

              </div>
              <div style={{ display: 'flex', gap: '10px' }}>
                {socialMedia.map((social, index) => (
                    <a key={index} href={social.url} target="_blank" rel="noopener noreferrer">
                    <img
                        src={getSocialIcon(social.platform)}
                        alt={social.platform}
                        style={{ width: '24px', height: '24px' }}
                    />
                    </a>
                ))}
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailSignature;